import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPencil } from '@fortawesome/pro-regular-svg-icons';
import { RootState } from '../../store';
import { Input } from '../UI/V3/Forms/Input/Input';
import Button from '../UI/V3/Button/Button';
import { getAuthUserDisplayName } from '../../actions/login/OrganizationsLoginConverter';
import styles from './PersonalInfoContent.module.scss';

export const PersonalInfoContent: React.FC = () => {
    const { auth } = useSelector((state: RootState) => state.login);
    const [formData, setFormData] = useState({
        firstName: auth?.user?.firstName || '',
        lastName: auth?.user?.lastName || '',
        email: auth?.user?.email || '',
        phone: '', // TODO: Add phone to user model
        address: '' // TODO: Add address to user model
    });

    // Get user initials for avatar
    const getUserInitials = (): string => {
        if (!auth?.user) return 'U';
        
        const firstName = auth.user.firstName || '';
        const lastName = auth.user.lastName || '';
        
        if (firstName && lastName) {
            return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
        }
        
        if (firstName) {
            return firstName.charAt(0).toUpperCase();
        }
        
        if (auth.user.email) {
            return auth.user.email.charAt(0).toUpperCase();
        }
        
        return 'U';
    };

    const handleInputChange = (field: string, value: string) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = () => {
        // TODO: Implement save functionality
        console.log('Saving personal info:', formData);
    };

    return (
        <div className={styles.personalInfoContent}>
            <div className={styles.header}>
                <h2 className={styles.title}>Personal info</h2>
            </div>

            <div className={styles.content}>
                {/* Avatar Section */}
                <div className={styles.avatarSection}>
                    <div className={styles.avatar}>
                        {getUserInitials()}
                        <button 
                            className={styles.editAvatarButton}
                            onClick={() => console.log('Edit avatar')}
                            aria-label="Edit avatar"
                        >
                            <FontAwesomeIcon icon={faPencil} />
                        </button>
                    </div>
                </div>

                {/* Form Section */}
                <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
                    <div className={styles.formRow}>
                        <div className={styles.formField}>
                            <Input
                                id="email"
                                label="Work email"
                                type="email"
                                value={formData.email}
                                onChange={(e) => handleInputChange('email', e.target.value)}
                                placeholder="john@email.com"
                            />
                        </div>
                        <div className={styles.formField}>
                            <Input
                                id="phone"
                                label="Phone number"
                                type="tel"
                                value={formData.phone}
                                onChange={(e) => handleInputChange('phone', e.target.value)}
                                placeholder="(___) ___-____"
                            />
                        </div>
                    </div>

                    <div className={styles.formRow}>
                        <div className={styles.formField}>
                            <Input
                                id="address"
                                label="Address"
                                value={formData.address}
                                onChange={(e) => handleInputChange('address', e.target.value)}
                                placeholder="Enter address"
                            />
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className={styles.actions}>
                        <Button
                            label="Save"
                            variant="black"
                            size="large"
                            onClick={handleSave}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PersonalInfoContent;
